import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './TermsOfServices.css';

const TermsOfServices = () => {
  const EFFECTIVE_DATE = '10th Feb, 2026';
  const LAST_UPDATED = '10th Feb, 2026';
  const SUPPORT_EMAIL = 'privacy@shipmnts.com';



  return (
    <section className="terms-container first-section">
      <Helmet>
        <title>Terms of Service | Shipmnts</title>
        <meta
          name="description"
          content="Terms of Service for Shipmnts.com - Read our terms and conditions for using our platform."
        />
      </Helmet>

      <div className="terms-content">
        <h1 className="terms-title">Terms of Service</h1>

        <div className="effective-dates">
          <p>
            <strong>Effective Date:</strong> {EFFECTIVE_DATE}
          </p>
          <p>
            <strong>Last Updated:</strong> {LAST_UPDATED}
          </p>
        </div>

        <p className="intro-text">
          By accessing this Website, accessible from shipmnts.com, you are agreeing to be bound by
          these Terms and Conditions of Use. Please read them carefully before using our services.
        </p>

        {/* Section 1 */}
        <div className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing this Website, you are agreeing to be bound by these Website Terms and
            Conditions of Use and agree that you are responsible for compliance with any applicable
            local laws. If you disagree with any of these terms, you are prohibited from accessing
            this site. The materials contained in this Website are protected by copyright and
            trademark law.
          </p>
        </div>

        {/* Section 2 */}
        <div className="terms-section">
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily download one copy of the materials on Logistixian
            Technologies Private Limited's Website for personal, non-commercial transitory viewing
            only. This is the grant of a license, not a transfer of title, and under this license
            you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>
              Attempt to reverse engineer any software contained on Logistixian Technologies Private
              Limited's Website
            </li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>
              Transfer the materials to another person or "mirror" the materials on any other server
            </li>
          </ul>
          <p>
            This license shall automatically terminate if you violate any of these restrictions.
            Upon termination, your viewing right will also be terminated and you should destroy any
            downloaded materials in your possession whether in printed or electronic format.
          </p>
        </div>

        {/* Section 3 */}
        <div className="terms-section">
          <h2>3. Disclaimer</h2>
          <p>
            All materials on Logistixian Technologies Private Limited's Website are provided "as
            is". Logistixian Technologies Private Limited makes no warranties, whether expressed or
            implied, and hereby disclaims all other warranties. Furthermore, Logistixian
            Technologies Private Limited does not make any representations concerning the accuracy
            or reliability of the use of the materials on its Website or otherwise relating to such
            materials or any sites linked to this Website.
          </p>
        </div>

        {/* Section 4 */}
        <div className="terms-section">
          <h2>4. Limitations of Liability</h2>
          <p>
            Logistixian Technologies Private Limited or its suppliers shall not be held accountable
            for any damages that arise with the use or inability to use the materials on
            Logistixian Technologies Private Limited's Website, even if Logistixian Technologies
            Private Limited or an authorized representative of this Website has been notified,
            orally or in writing, of the possibility of such damage.
          </p>
          <p>
            Some jurisdictions do not allow limitations on implied warranties or limitations of
            liability for incidental damages; these limitations may not apply to you.
          </p>
        </div>

        {/* Section 5 */}
        <div className="terms-section">
          <h2>5. Revisions and Errata</h2>
          <p>
            The materials appearing on Logistixian Technologies Private Limited's Website may
            include technical, typographical, or photographic errors. Logistixian Technologies
            Private Limited does not warrant that any of the materials on this Website are accurate,
            complete, or current.
          </p>
          <p>
            Logistixian Technologies Private Limited may make changes to the materials contained on
            its Website at any time without notice. Logistixian Technologies Private Limited does
            not make any commitment to update the materials.
          </p>
        </div>

        {/* Section 6 */}
        <div className="terms-section">
          <h2>6. Links to Third-Party Sites</h2>
          <p>
            Logistixian Technologies Private Limited has not reviewed all of the sites linked to its
            Website and is not responsible for the contents of any such linked site. The presence of
            any link does not imply endorsement by Logistixian Technologies Private Limited of the
            site.
          </p>
          <p>The use of any linked website is at the user's own risk.</p>
        </div>

        {/* Section 7 */}
        <div className="terms-section">
          <h2>7. Modifications to Terms</h2>
          <p>
            Logistixian Technologies Private Limited may revise these Terms of Service for its
            Website at any time without prior notice. By using this Website, you are agreeing to be
            bound by the current version of these Terms and Conditions of Use.
          </p>
        </div>

        {/* Section 8 */}
        <div className="terms-section">
          <h2>8. Governing Law</h2>
          <p>
            Any claim related to Logistixian Technologies Private Limited's Website shall be
            governed by the laws of India, without regard to its conflict of law provisions. All
            disputes shall be subject to the exclusive jurisdiction of the courts in Ahmedabad,
            Gujarat, India.
          </p>
        </div>

        {/* Section 9 */}
        <div className="terms-section contact-section">
          <h2>9. Contact Information</h2>
          <p>If you have any questions regarding these Terms of Service, please contact us:</p>
          <div className="contact-card">
            <p className="company-name">Logistixian Technologies Private Limited</p>
            <p>
              <strong>Address:</strong>
              <br />
              A-28, Pariseema Complex,
              <br />
              Chimanlal Girdharlal Rd, Ellisbridge,
              <br />
              Ahmedabad, Gujarat 380006
            </p>
            <p>
              <strong>Email:</strong> <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
          </div>
        </div>

        {/* Related Links */}
        <div className="terms-section related-links no-print">
          <h2>Related Policies</h2>
          <div className="links-container">
            <Link to="/privacy-policy" className="policy-link">
              Privacy Policy
            </Link>
            <Link to="/cookie-policy" className="policy-link">
              Cookie Policy
            </Link>
          </div>
        </div>


      </div>
    </section>
  );
};

export default TermsOfServices;
